import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Partners from "@/pages/Partners";
import WhyUs from "@/pages/WhyUs";
import References from "@/pages/References";
import Contact from "@/pages/Contact";
import LegalPage from "@/pages/Legal";
import NotFound from "@/pages/NotFound";

import { AdminProvider } from "@/admin/AdminContext";
import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import AdminDashboard from "@/admin/Dashboard";
import AccountSettings from "@/admin/AccountSettings";
import SiteSettings from "@/admin/SiteSettings";
import ReferencesAdmin from "@/admin/References";
import TestimonialsAdmin from "@/admin/Testimonials";
import MessagesAdmin from "@/admin/Messages";

function PublicShell({ element }) {
  return <Layout>{element}</Layout>;
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <AdminProvider>
            <Routes>
              {/* Admin (no public layout) */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="hesap" element={<AccountSettings />} />
                <Route path="site-ayarlari" element={<SiteSettings />} />
                <Route path="referanslar" element={<ReferencesAdmin />} />
                <Route path="yorumlar" element={<TestimonialsAdmin />} />
                <Route path="mesajlar" element={<MessagesAdmin />} />
              </Route>

              {/* Public site */}
              <Route path="/" element={<PublicShell element={<Home />} />} />
              <Route path="/hakkimizda" element={<PublicShell element={<About />} />} />
              <Route path="/hizmetler" element={<PublicShell element={<Services />} />} />
              <Route path="/hizmetler/:slug" element={<PublicShell element={<ServiceDetail />} />} />
              <Route path="/is-ortaklari" element={<PublicShell element={<Partners />} />} />
              <Route path="/neden-biz" element={<PublicShell element={<WhyUs />} />} />
              <Route path="/referanslar" element={<PublicShell element={<References />} />} />
              <Route path="/iletisim" element={<PublicShell element={<Contact />} />} />
              <Route path="/kvkk" element={<PublicShell element={<LegalPage type="kvkk" />} />} />
              <Route path="/gizlilik" element={<PublicShell element={<LegalPage type="gizlilik" />} />} />
              <Route path="/cerez-politikasi" element={<PublicShell element={<LegalPage type="cerez" />} />} />
              <Route path="*" element={<PublicShell element={<NotFound />} />} />
            </Routes>
          </AdminProvider>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
